import React, { Component } from 'react';
import AddToDo from './components/AddToDo';
import ToDoList from './components/ToDoList';
import firedb from './fire';

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      items: []
    }
  }

  componentWillMount() {
    let todosRef = firedb.database().ref('todo-items').orderByKey().limitToLast(50);
    /* todosRef.once('value', snapshot => {
      snapshot.forEach(child => {
        //console.log(child.val())
        let todoItem = child.val()
        this.setState({ items: this.state.items.concat(todoItem) })
      })
    }); */

    todosRef.on('child_added', snapshot => {
      let todoItem = snapshot.val()
      console.log(todoItem)
      this.setState({ items: this.state.items.concat(todoItem) })
    })

    todosRef.on('child_removed', snapshot => {
      let todoItem = snapshot.val()
      console.log("Item Removed ", todoItem)
      let items = this.state.items
      let index = items.findIndex(item => item.id === todoItem.id)
      console.log("index to remove", index)
      items.splice(index, 1)
      console.log('New Array', items)
      this.setState({ items: items })
    })

    todosRef.on('child_changed', snapshot => {
      let updatedItem = snapshot.val()
      console.log("Item Updated ", updatedItem)
      let items = this.state.items
      let index = items.findIndex(item => item.id === updatedItem.id)
      console.log("Updated Item Index ", index)
      items[index] = updatedItem
      this.setState({ items: items })
    })
  }

  handleOnAdd(todo) {
    // Push to get ref key
    var pushRef = firedb.database().ref('todo-items').push()
    var newTask = { "id": pushRef.key, "task": todo, "done": false }
    pushRef.set(newTask)
  }

  handleItemUpdated(todoItem) {
    // will need to update this items state
    console.log("Done State Changed: ", todoItem)
    firedb.database().ref('todo-items/' + todoItem.id).set(todoItem)
  }

  handleItemDelete(todoItem) {
    console.log("Will Delete Item: ", todoItem)
    firedb.database().ref('todo-items/' + todoItem.id).remove()
  }

  render() {
    return (
      <div className="container">
        <header className="jumbotron ">
          <div className="container">
            <h1 className="display-4">React ToDo App</h1>
          </div>
        </header>
        <AddToDo onAdd={(item) => this.handleOnAdd(item)} />

        <ToDoList items={this.state.items} onItemUpdated={(todoItem) => this.handleItemUpdated(todoItem)} onItemDelete={(todoItem) => this.handleItemDelete(todoItem)} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js